import { CALL_API } from '../middleware/api';

export const FETCH_CALLBACKS = "FETCH_CALLBACKS";
export const SUCCESS_FETCH_CALLBACKS = "SUCCESS_FETCH_CALLBACKS";
export const FAILURE_FETCH_CALLBACKS = "FAILURE_FETCH_CALLBACKS";

export const UPDATE_CALLBACK = "UPDATE_CALLBACK";
export const SUCCESS_UPDATE_CALLBACK = "SUCCESS_UPDATE_CALLBACK";
export const FAILURE_UPDATE_CALLBACK = "FAILURE_UPDATE_CALLBACK";
export const CLEAR_UPDATE_CALLBACK = "CLEAR_UPDATE_CALLBACK";

export const FETCH_CALLBACK_HISTORY = "FETCH_CALLBACK_HISTORY";
export const SUCCESS_FETCH_CALLBACK_HISTORY = "SUCCESS_FETCH_CALLBACK_HISTORY";
export const FAILURE_FETCH_CALLBACK_HISTORY = "FAILURE_FETCH_CALLBACK_HISTORY";

export const CLEAR_CALLBACK = "CLEAR_CALLBACK";

export function fetchCallbackEnquiry() {
    return {
        type: FETCH_CALLBACKS,
        [CALL_API]: {
            endpoint: '/api/callback',
            method: 'get',
            types: [SUCCESS_FETCH_CALLBACKS, FAILURE_FETCH_CALLBACKS]
        }
    }
}

export function updateCallback(data) {
    const { Id } = data;
    return {
        type: UPDATE_CALLBACK,
        [CALL_API]: {
            endpoint: `/api/callback/update/${Id}`,
            method: 'post',
            types: [SUCCESS_UPDATE_CALLBACK, FAILURE_UPDATE_CALLBACK],
            data
        }
    }
}

export function clearUpdateCallback() {
    return { type: CLEAR_UPDATE_CALLBACK }
}

export function clearCalback() {
    return{type: CLEAR_CALLBACK}
}

export function fetchCallbackHistory() {
    return {
        type: FETCH_CALLBACK_HISTORY,
        [CALL_API]: {
            endpoint: '/api/callback/history',
            method: 'get',
            types: [SUCCESS_FETCH_CALLBACK_HISTORY, FAILURE_FETCH_CALLBACK_HISTORY]
        }
    }
}


// WEBPACK FOOTER //
// ./src/actions/callback.js